import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { categoriesArrayPropTypes, productsArrayPropTypes, slidersArrayPropTypes } from 'helpers/propTypes';
import { MOST_SELLED, NEW_ARRIVALS, OFFERS } from 'views/Home/constants';
import { sendNewsletter } from 'redux/actions/user.actions';
import { getProductsHome, getMostSelledHome } from 'redux/actions/product.actions';

import ItemContainer from 'containers/ItemContainer';
import Home from 'views/Home';

const HomeContainer = (props) => {
  const {
    cartel, categories, categoriesHome, instagram, loadingProd, loadingMostSelled, marcasHome, newArrivals,
    minimumPurchase, offers, sliders, sendNewsletterAction, subCategoriesHome, mostSelled, loadingOffers,
    loading,section
  } = props;
  const [currentSection, setCurrentSeccion] = useState(NEW_ARRIVALS);
  const [currentSection1, setCurrentSeccion1] = useState();
  const [newsletter, setNewsletter] = useState('');
  const [items, setItems] = useState(newArrivals);
  const [filteredLinks, setFilteredLinks] = useState([]);
  
  useEffect(() => {
    // eslint-disable-next-line no-use-before-define
    setNewSection(section);
    // eslint-disable-next-line
  }, [mostSelled, newArrivals, offers]);

  useEffect(() => {
    setFilteredLinks(filterInstagramLinks(instagram));
  }, [instagram]);

  const setNewSection = (newSection) => {
    switch (newSection) {
      case OFFERS.value:
        setCurrentSeccion(OFFERS);
        setItems(offers);
        break;
      case MOST_SELLED.value:
        setCurrentSeccion(MOST_SELLED);
        setItems(mostSelled);
        break;
      default:
        setCurrentSeccion(NEW_ARRIVALS);
        setItems(newArrivals);
        break;
    }
  }; 

  const filterItems = (subcat) => {
    if (subcat) {
      setCurrentSeccion(subcat.subCategory_id);
    } else {
      setCurrentSeccion(-1);
    }
  };

  const filterItems1 = (subcat) => {
    if (subcat) {
      setCurrentSeccion1(subcat.subCategory_id);
    } else {
      setCurrentSeccion1(-1);
    }
  };

  const renderItem = (item) => (
    <div className="col-products" key={`item-${item.id}`}>
      <ItemContainer item={item} />
    </div>
  );

  const submitNewsletter = () => {
    const value = { email: newsletter };
    sendNewsletterAction(value);
  };

  const filterInstagramLinks = (instagram) => {
    const regex = /^(https?:\/\/.*\/)$/;
    const filteredLinks = instagram.filter((link) => regex.test(link.link));
    return filteredLinks;
  }

  const getImageHomeSelected = (categoryHome) => {
    if (!categoryHome || !categoryHome.category) return '';
    const variant = Number(categoryHome.image_home_selected) || 1;
    const key = variant === 1 ? 'imageHome' : `imageHome${variant}`;
    return categoryHome.category[key] || categoryHome.category.imageHome;
  };

  return (
    <Home
      cartel={cartel}
      categories={categories}
      categoriesHome={categoriesHome}
      getImageHomeSelected={getImageHomeSelected}
      subCategoriesHome={subCategoriesHome}
      currentSection={currentSection}
      currentSection1={currentSection1}
      instagram={filteredLinks}
      items={items}
      mostSelled={mostSelled}
      offers={offers}
      loadingProd={loadingProd}
      loadingMostSelled = {loadingMostSelled}
      loadingOffers = {loadingOffers}
      marcasHome={marcasHome}
      minimumPurchase={minimumPurchase}
      onSectionClick={setNewSection}
      renderItem={renderItem}
      sliders={sliders}
      submitNewsletter={submitNewsletter}
      setNewsletter={setNewsletter}
      tiktok="7132849512812416261"
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  sendNewsletterAction: bindActionCreators(sendNewsletter, dispatch),
});

const mapStateToProps = (state, props) => ({
  cartel: state.category.cartelHome,
  categories: state.category.items,
  categoriesHome: state.category.itemsHome,
  instagram: state.app.instagram,
  products: state.product.items,
  loading: state.product.loading,
  loadingProd: state.product.loadingProd,
  loadingMostSelled: state.product.loadingMostSelled,
  loadingOffers: state.product.loadingOffers,
  marcasHome: state.category.marcasHome,
  minimumPurchase: state.app.minimumPurchase,
  mostSelled: state.product.mostSelled,
  newArrivals: state.product.newArrivals,
  offers: state.product.offers,
  section: props.match.params.section,
  sliders: state.app.sliders,
  subCategories: state.subCategory.items,
  subCategoriesHome: state.subCategory.itemsHome,
  loadingNewsletter: state.user.loadingNewsletter,
});

HomeContainer.defaultProps = {
  // section: '',
};

HomeContainer.propTypes = {
  cartel: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  categories: categoriesArrayPropTypes.isRequired,
  categoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  instagram: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
  // loadingNewsletter: PropTypes.bool.isRequired,
  marcasHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  minimumPurchase: PropTypes.number.isRequired,
  mostSelled: productsArrayPropTypes.isRequired,
  newArrivals: productsArrayPropTypes.isRequired,
  offers: productsArrayPropTypes.isRequired,
  products: productsArrayPropTypes.isRequired,
  // section: PropTypes.string,
  sendNewsletterAction: PropTypes.func.isRequired,
  sliders: slidersArrayPropTypes.isRequired,
  subCategoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);
